import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import "./agGrid.css";

const ThemeableAgGrid = ({
  rowData = [],
  columnDefs = [],
  gridOptions = {},
  className = "",
  style = {},
  height = 500,
  width = "100%",
  onGridReady = () => {},
  onSelectionChanged = () => {},
  onFirstDataRendered = () => {},
  onGridSizeChanged = () => {},
  onRowDataUpdated = () => {},
  allowHorizontalScroll = false,
  ...otherProps
}) => {
  const defaultOptions = useMemo(
    () => ({
      suppressCellFocus: true,
      paginationPageSize: 10,
      paginationPageSizeSelector: [10, 20, 50, 100],
      suppressContextMenu: true,
      headerHeight: 45,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        type: "centerAligned",
        tooltipValueGetter: (params) => params.value,
        wrapHeaderText: false,
        autoHeaderHeight: true,
      },
      columnTypes: {
        centerAligned: {
          cellClass: "ag-center-aligned-cell",
          headerClass: "ag-center-aligned-header",
        },
        leftAligned: {
          cellClass: "ag-left-aligned-cell",
          headerClass: "ag-left-aligned-header",
        },
      },
      colResizeDefault: "shift",
      domLayout: "autoHeight",
      autoSizeStrategy: allowHorizontalScroll
        ? {
            type: "fitCellContents",
            skipHeader: false,
            defaultMinWidth: 0,
          }
        : {
            type: "fitGridWidth",
          },
      autoSizePadding: 10,
      skipHeaderOnAutoSize: false,
      enableCellTextSelection: true,
      tooltipShowMode: "whenTruncated",
    }),
    [allowHorizontalScroll]
  );

  const combinedGridOptions = useMemo(
    () => ({
      ...defaultOptions,
      ...gridOptions,
      defaultColDef: {
        ...defaultOptions.defaultColDef,
        ...gridOptions.defaultColDef,
      },
      columnTypes: {
        ...defaultOptions.columnTypes,
        ...gridOptions.columnTypes,
      },
    }),
    [defaultOptions, gridOptions]
  );

  const domLayout = otherProps.domLayout || combinedGridOptions.domLayout;
  const containerStyle = {
    height: domLayout === "normal" ? height : "auto",
    width: width,
    ...(allowHorizontalScroll ? { overflowX: "auto" } : {}),
    ...style,
  };

  return (
    <div style={containerStyle}>
      <AgGridReact
        className={`${className}`}
        rowData={rowData}
        columnDefs={columnDefs}
        onGridReady={onGridReady}
        onFirstDataRendered={onFirstDataRendered}
        onGridSizeChanged={onGridSizeChanged}
        onRowDataUpdated={onRowDataUpdated}
        onSelectionChanged={onSelectionChanged}
        modules={[AllCommunityModule]}
        suppressColumnVirtualisation={allowHorizontalScroll}
        {...combinedGridOptions}
        {...otherProps}
      />
    </div>
  );
};

export default ThemeableAgGrid;
